import {
  Button,
  Columns,
  Container,
  Content,
  Footer,
  Heading,
  Navbar,
  Section,
} from "react-bulma-components";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronUp,
  faMobileScreen,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { RedirectTo } from "../../utils/redirectTo";
import { Images } from "./images";
import "../../../node_modules/bulma/css/bulma.min.css";
import "./styles.css";
import WhatsappButton from "./components/WhatsappButton";

export const HomePage = () => {
  const links = {
    googlePlay: process.env.REACT_APP_ZAD_GOOGLE_PLAY||'',
    appleStore: process.env.REACT_APP_ZAD_APPLE_STORE||'',
  };

  const city = process.env.REACT_APP_CITY||''
  const state = process.env.REACT_APP_STATE||''
  const local = city ? city + ' - ' + state : ''

  return (
    <>
      <Navbar className="is-fixed-top">
        <Container className="is-justify-content-space-between">
          <Navbar.Brand className="ml-0 is-align-items-center">
            <img src={Images.prancheta113} alt="" className="logo-home" />
          </Navbar.Brand>

          <Button.Group className="py-1" align="right">
            <Button
              id="login"
              className=""
              to={RedirectTo.login}
              renderAs={Link}
              rounded
              outlined
            >
              Entrar
            </Button>
            <Button
              id="register"
              className=""
              to={RedirectTo.register}
              renderAs={Link}
              rounded
              color={"link"}
            >
              Cadastre-se
            </Button>
          </Button.Group>
        </Container>
      </Navbar>
      <Section id="topo" />
      <Section className="section-hero">
        <Container>
          <p className="">
            <img src={Images.appIcon} alt="" className="icon-app" />
          </p>
          <h1 className="title">
            Aplicativo <strong>Zona Azul Digital - ZAD</strong> { local ? 'em ' + local : '' }
          </h1>
          <p className="texto-app">
            Aplicativo oficial credenciado { local ? 'pela Prefeitura Municipal de ' + local + ' ' : '' }
            para utilização do estacionamento rotativo Zona Azul.
            Toda praticidade e segurança na hora de estacionar.
          </p>

          <Columns gap={8} centered breakpoint={"mobile"}>
            <Columns.Column
              textAlign={"center"}
              className="is-half-mobile is-one-quarter-desktop"
            >
              <img src={Images.appFtz01} alt="" className="img-app" />
            </Columns.Column>
            <Columns.Column
              textAlign={"center"}
              className="is-half-mobile is-one-quarter-desktop"
            >
              <img src={Images.appFtz02} alt="" className="img-app" />
            </Columns.Column>
            <Columns.Column
              textAlign={"center"}
              className="is-half-mobile is-one-quarter-desktop"
            >
              <img src={Images.appFtz03} alt="" className="img-app" />
            </Columns.Column>
            <Columns.Column
              textAlign={"center"}
              className="is-half-mobile is-one-quarter-desktop"
            >
              <img src={Images.appFtz04} alt="" className="img-app" />
            </Columns.Column>
          </Columns>

          <p className="mb-3">Baixe o App nas seguintes lojas</p>

          <div className='is-flex is-justify-content-center' style={{ gap:'8px' }}>
            <a href={city ? links.appleStore : ''}>
              <svg width="130" height="42" viewBox="0 0 130 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="128" height="40" rx="8" stroke="white"></rect><path fillRule="evenodd" clipRule="evenodd" d="M30.9739 19.8687C30.9492 17.2875 33.1004 16.0323 33.1993 15.973C31.9812 14.2065 30.0946 13.9653 29.4303 13.9465C27.846 13.7818 26.3067 14.8911 25.4971 14.8911C24.6744 14.8911 23.4317 13.9638 22.093 13.9927C20.3648 14.0173 18.7514 15.011 17.8662 16.5508C16.0421 19.6939 17.4026 24.3118 19.1511 26.8511C20.029 28.0963 21.0509 29.4858 22.391 29.4367C23.6991 29.3833 24.1875 28.6076 25.7689 28.6076C27.3358 28.6076 27.7937 29.4367 29.16 29.4064C30.5684 29.3833 31.4521 28.1555 32.2966 26.9003C33.3068 25.4746 33.7167 24.0691 33.7298 23.9969C33.6978 23.9883 31.003 22.9656 30.9739 19.8687Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M29.4467 9C28.4263 9.04478 27.1516 9.70056 26.4176 10.5571C25.7693 11.314 25.1864 12.5504 25.3376 13.7132C26.483 13.797 27.6603 13.1383 28.3929 12.2774C29.0993 11.4007 29.5804 10.2104 29.4467 9Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M45.4274 22.2456L47.1745 17.1337H47.2239L48.971 22.2456H45.4274ZM46.2341 15.1953L42 26.8491H43.891L44.9666 23.6988H49.4361L50.5074 26.8491H52.4333L48.1992 15.1953H46.2341Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M57.5138 25.4589C56.1722 25.4589 55.2711 24.3135 55.2711 22.6004C55.2711 20.906 56.1722 19.7505 57.5138 19.7505C58.8787 19.7505 59.7755 20.88 59.7755 22.6004C59.7755 24.338 58.8787 25.4589 57.5138 25.4589ZM57.976 18.2642C56.7827 18.2642 55.742 18.8549 55.2536 19.7664H55.2216V18.3523H53.5239V29.6594H55.2783V25.4517H55.319C55.8234 26.3949 56.7914 26.9366 58.0094 26.9366C60.1548 26.9366 61.5778 25.2423 61.5778 22.6004C61.5778 19.9672 60.1475 18.2642 57.976 18.2642Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M66.9249 25.4589C65.5834 25.4589 64.6822 24.3135 64.6822 22.6004C64.6822 20.906 65.5834 19.7505 66.9249 19.7505C68.2898 19.7505 69.1866 20.88 69.1866 22.6004C69.1866 24.338 68.2898 25.4589 66.9249 25.4589ZM67.3871 18.2642C66.1938 18.2642 65.1531 18.8549 64.6647 19.7664H64.6327V18.3523H62.9336V29.6594H64.6894V25.4517H64.7301C65.2345 26.3949 66.2025 26.9366 67.4206 26.9366C69.5659 26.9366 70.9889 25.2423 70.9889 22.6004C70.9889 19.9672 69.5587 18.2642 67.3871 18.2642Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M81.0028 20.2664L79.7106 19.9516C78.199 19.5789 77.5812 19.095 77.5812 18.2717C77.5812 17.2374 78.5507 16.5268 79.9621 16.5268C81.3763 16.5268 82.3444 17.2288 82.4505 18.3916H84.2223C84.167 16.3823 82.4664 15 79.9882 15C77.4838 15 75.7193 16.3823 75.7193 18.3916C75.7193 20.0166 76.7222 21.019 78.8734 21.5347L80.3937 21.8987C81.9127 22.2699 82.5551 22.8116 82.5551 23.7158C82.5551 24.7572 81.4911 25.517 80.0115 25.517C78.4679 25.517 77.3385 24.7572 77.2106 23.6031H75.4111C75.5245 25.7106 77.2803 27.0423 79.8821 27.0423C82.6627 27.0423 84.4112 25.6773 84.4112 23.4962C84.4112 21.7932 83.4083 20.8327 81.0028 20.2664Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M88.1963 16.3408H86.4332V18.3529H85.1919V19.7338H86.4332V24.6045C86.4332 26.2512 87.1076 26.8983 88.8387 26.8983C89.2297 26.8983 89.6193 26.865 89.814 26.8159V25.4452C89.7007 25.4582 89.4158 25.4842 89.237 25.4842C88.5248 25.4842 88.1963 25.1462 88.1963 24.4182V19.7338H89.8228V18.3529H88.1963V16.3408Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M94.8194 25.5167C93.3964 25.5167 92.5519 24.4421 92.5519 22.599C92.5519 20.7761 93.3964 19.6841 94.8194 19.6841C96.2424 19.6841 97.0898 20.7674 97.0898 22.599C97.0898 24.4421 96.2424 25.5167 94.8194 25.5167ZM94.8194 18.2483C92.3485 18.2483 90.7642 19.9282 90.7642 22.599C90.7642 25.2813 92.3325 26.9554 94.8194 26.9554C97.3064 26.9554 98.8762 25.2813 98.8762 22.599C98.8762 19.9282 97.2977 18.2483 94.8194 18.2483Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M102.037 19.7982H101.998V18.3523H100.322V26.8485H102.077V21.8103C102.077 20.6143 102.777 19.8545 103.907 19.8545C104.248 19.8545 104.556 19.9036 104.694 19.9599V18.3277C104.556 18.2959 104.346 18.2642 104.094 18.2642C103.088 18.2642 102.308 18.8362 102.037 19.7982Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M106.854 21.8168C106.944 20.5327 107.82 19.6617 109.031 19.6617C110.251 19.6617 111.088 20.5182 111.129 21.8168H106.854ZM109.031 18.2476C106.628 18.2476 105.073 19.978 105.073 22.6401C105.073 25.2979 106.618 26.9561 109.105 26.9561C111.04 26.9561 112.552 25.8959 112.787 24.3547H111.123C110.884 25.0899 110.121 25.5478 109.146 25.5478C107.765 25.5478 106.847 24.5959 106.847 23.1413V23.0373H112.884V22.4393C112.884 19.861 111.397 18.2476 109.031 18.2476Z" fill="white"></path>
              </svg>
            </a>
            <a href={city ? links.googlePlay : ''}>
              <svg width="143" height="42" viewBox="0 0 143 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="141" height="40" rx="8" stroke="white"></rect><path d="M17 9V32M17 9L31.5 17.1341M17 9L31.5 23.8659M17 32L31.5 17.1341M17 32L31.5 23.8659M31.5 17.1341L35.9453 19.6279C36.6263 20.0099 36.6263 20.9901 35.9453 21.3721L31.5 23.8659" stroke="white" strokeWidth="2" strokeLinejoin="round"></path><path fillRule="evenodd" clipRule="evenodd" d="M52.2812 19.6174V21.3046H56.3277C56.206 22.2536 55.8903 22.9454 55.4066 23.4279C54.8171 24.0143 53.896 24.6629 52.2812 24.6629C49.7887 24.6629 47.8422 22.6594 47.8422 20.175C47.8422 17.6906 49.7887 15.6871 52.2812 15.6871C53.6252 15.6871 54.6042 16.2143 55.3298 16.8918L56.5246 15.7016C55.5108 14.7381 54.1683 14 52.2812 14C48.869 14 46 16.7719 46 20.175C46 23.5781 48.869 26.35 52.2812 26.35C54.1219 26.35 55.5108 25.7477 56.5985 24.6167C57.7166 23.503 58.0641 21.9372 58.0641 20.6704C58.0641 20.2804 58.0337 19.9179 57.9743 19.6174H52.2812Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M71.3927 24.7831C70.1848 24.7831 69.1435 23.7894 69.1435 22.3738C69.1435 20.9424 70.1848 19.9645 71.3927 19.9645C72.6006 19.9645 73.6448 20.9424 73.6448 22.3738C73.6448 23.7894 72.6006 24.7831 71.3927 24.7831ZM71.3927 18.3987C69.1899 18.3987 67.3911 20.0699 67.3911 22.3738C67.3911 24.6632 69.1899 26.3489 71.3927 26.3489C73.597 26.3489 75.3957 24.6632 75.3957 22.3738C75.3957 20.0699 73.597 18.3987 71.3927 18.3987Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M62.6637 24.7831C61.4558 24.7831 60.4145 23.7894 60.4145 22.3738C60.4145 20.9424 61.4558 19.9645 62.6637 19.9645C63.8716 19.9645 64.9158 20.9424 64.9158 22.3738C64.9158 23.7894 63.8716 24.7831 62.6637 24.7831ZM62.6637 18.3987C60.4609 18.3987 58.6621 20.0699 58.6621 22.3738C58.6621 24.6632 60.4609 26.3489 62.6637 26.3489C64.868 26.3489 66.6667 24.6632 66.6667 22.3738C66.6667 20.0699 64.868 18.3987 62.6637 18.3987Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M80.0996 24.7831C78.8918 24.7831 77.8809 23.7749 77.8809 22.3883C77.8809 20.9886 78.8918 19.9645 80.0996 19.9645C81.293 19.9645 82.23 20.9886 82.23 22.3883C82.23 23.7749 81.293 24.7831 80.0996 24.7831ZM82.1098 19.2856H82.049C81.6551 18.8205 80.902 18.3987 79.949 18.3987C77.9576 18.3987 76.1299 20.145 76.1299 22.3882C76.1299 24.617 77.9576 26.3489 79.949 26.3489C80.902 26.3489 81.6551 25.9271 82.049 25.4461H82.1098V26.0167C82.1098 27.5391 81.293 28.3523 79.9794 28.3523C78.9077 28.3523 78.2444 27.5825 77.9706 26.9368L76.4471 27.5695C76.883 28.6239 78.046 29.9196 79.9794 29.9196C82.0316 29.9196 83.7695 28.7135 83.7695 25.7755V18.6385H82.1098V19.2856Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M84.9766 26.1096H86.7275V14.4226H84.9766V26.1096Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M89.3112 22.2524C89.2663 20.7184 90.5046 19.9355 91.3938 19.9355C92.089 19.9355 92.6784 20.2808 92.8754 20.7777L89.3112 22.2524ZM94.7466 20.9279C94.4135 20.0396 93.404 18.3972 91.333 18.3972C89.2808 18.3972 87.5747 20.0078 87.5747 22.3723C87.5747 24.6011 89.2663 26.3503 91.5314 26.3503C93.3577 26.3503 94.4135 25.2338 94.8537 24.5867L93.4938 23.6839C93.0405 24.3454 92.4206 24.7817 91.5314 24.7817C90.6393 24.7817 90.0049 24.3772 89.5979 23.577L94.9291 21.38L94.7466 20.9279Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M102.997 20.0548H100.509V16.0493H102.997C104.304 16.0493 105.048 17.1283 105.048 18.0513C105.048 18.957 104.304 20.0548 102.997 20.0548ZM102.953 14.4229H98.7612V26.1084H100.509V21.6812H102.953C104.89 21.6812 106.796 20.2815 106.796 18.0513C106.796 15.8211 104.89 14.4229 102.953 14.4229Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M107.761 26.1096H109.509V14.4226H107.761V26.1096Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M113.594 24.7802C113.02 24.7802 112.224 24.4956 112.224 23.7879C112.224 22.8851 113.217 22.5399 114.076 22.5399C114.845 22.5399 115.207 22.7045 115.675 22.9327C115.54 24.0146 114.605 24.7802 113.594 24.7802ZM113.805 18.3755C112.538 18.3755 111.227 18.9316 110.684 20.1666L112.237 20.8123C112.568 20.1666 113.188 19.9543 113.836 19.9543C114.739 19.9543 115.659 20.4959 115.675 21.4579V21.5778C115.359 21.3973 114.68 21.1286 113.852 21.1286C112.177 21.1286 110.476 22.0429 110.476 23.7575C110.476 25.3218 111.844 26.3286 113.382 26.3286C114.558 26.3286 115.207 25.8028 115.616 25.186H115.675V26.0888H117.364V21.6096C117.364 19.5339 115.81 18.3755 113.805 18.3755Z" fill="white"></path><path fillRule="evenodd" clipRule="evenodd" d="M121.509 23.6982H121.448L119.367 18.6326H117.485L120.603 25.7132L118.825 29.6522H120.648L125.46 18.6326H123.515L121.509 23.6982Z" fill="white"></path>
              </svg>
            </a>
          </div>
        </Container>
      </Section>

      <Section className="question">
        <Container className="is-max-desktop">
          <Heading size={4} textAlign={"center"}>
            O que é o ZAD { city||'' }?
          </Heading>
          <p>
            ZAD { city||'' } é o mesmo que Zona Azul Digital { city ? 'de '+city : '' }!
            <br />
            <br />
            { city ? 'A cidade de '+local+' está ' : 'As cidades estão ' }
            passando por uma transformação com a nova sinalização. 
            E o sistema rotativo de vagas chegou para auxiliar no ordenamento 
            do trânsito e no uso das vagas de estacionamento. Ao estacionar, 
            você irá comprar e ativar um ou mais CAD, mais conhecidos como Cartão 
            Azul Digital, sempre observando as placas que visam demarcar e 
            orientar com clareza as regras para o uso das vagas rotativas.
          </p>

          <Heading subtitle size={5}>
            Inovação e tecnologia { city ? 'a serviço da cidade de '+city : 'a seu serviço' }
          </Heading>
          <p>
            O ZAD { city||'' } foi desenvolvido pensando em garantir o máximo de
            confiança e o mínimo de complexidade na hora de usar. Além disso, o
            ZAD permite diversas formas de pagamento em estacionamento rotativo
            digital. Baixe agora mesmo o aplicativo na App Store ou no Google
            Play.
          </p>

          <Heading subtitle size={5}>
            Como baixar o aplicativo ZAD { city||'' }?
          </Heading>
          <Content>
            <p>
              O ZAD chegou { city ? 'na cidade' : '' } de forma extremamente moderna! <br />{" "}
              <br />
              Nada de papelzinho para estacionar! É tudo digital! Tornando o
              processo de utilizar as vagas de Zona Azul { city ? 'em '+city : '' } muito mais
              fácil, rápido e seguro.
            </p>
            <ol>
              <li>
                Do seu celular, clique no link de uma das lojas a cima (App
                Store ou Google Play)
              </li>
              <li>
                Na sua loja de aplicativo, clique em <strong>instalar</strong> e
                aguarde o download
              </li>
              <li>Entre no app e faça seu cadastro</li>
              <li>Compre créditos antecipadamente</li>
              <li>
                Pronto. Quando desejar estacionar, você já poderá ativar o CAD
                { city ? 'em '+city : '' }
              </li>
            </ol>
          </Content>

          <Heading subtitle size={5}>
            Qual o preço do Cartão Azul Digital { city ? 'de '+city : '' }?
          </Heading>
          <p>
            O preço de cada CAD { city ? 'na cidade de '+city : '' } é de R$2,00 (dois reais).{" "}
            <br />
            <br />
            Esse é o valor oficial cobrado{ city ? 'pelo município ' : '' }. Então, não pague mais
            que isso por um cartão, nem no app e nem com nossos parceiros! O
            tempo de permanência para cada CAD é de 01 (uma) hora. E o máximo de
            cartões que você pode usar por vaga estacionada é de 02 CAD’s. Ou
            seja, duas horas. Após esse período você deve retirar seu veículo do
            local estacionado.
          </p>

          <Heading subtitle size={5}>
            Cartão Azul Digital em um Ponto de Venda?
          </Heading>
          <p style={{ marginBottom: 0 }}>
            Caso você não queira ou não possa baixar o app do ZAD{ city ? city+' ' : '' }, por
            qualquer motivo que seja, existe uma outra maneira de comprar o
            cartão digital. Você deve se dirigir até um Ponto de Venda
            regulamentado (PDV). Geralmente são locais como bancas, bares,
            restaurantes, farmácias etc.. No PDV, você informará a placa do seu
            veículo e pagará o valor de 01 ou 02 CAD, a depender de quanto tempo
            você pretender deixar o veículo naquela vaga. Após efetuar o
            pagamento do tíquete digital, você pode pedir para receber um
            comprovante por email, mas não é necessário deixar no painel do
            veículo.
            <br />
            <br />
          </p>
          <Heading size={5}>É tudo digital !!!</Heading>
        </Container>
      </Section>

      <Section className="asked-questions">
        <Container className="is-max-desktop">
          <Heading
            size={4}
            textAlign={"center"}
            style={{ marginBottom: "2.5rem" }}
          >
            Perguntas frequentes
          </Heading>

          <Heading subtitle size={5}>
            Os CADs comprados possuem prazo de validade?
          </Heading>
          <p>
            Os CADs adquiridos não possuem data de expiração. Enquanto houver
            CADs disponíveis no seu saldo, você poderá utilizá-los à medida que
            precisar, por tempo indeterminado.
          </p>

          <Heading subtitle size={5}>
            É possível trocar de vaga enquanto houver tempo disponível no CAD
            que ativei?
          </Heading>
          <p>
            É possível sim mudar o veículo de vaga enquanto o tempo do CAD ainda
            estiver ativo.
          </p>

          <Heading subtitle size={5}>
            Cliquei em "Estacionar" e ativei um CAD por engano! Tem como
            cancelar?
          </Heading>
          <p>
            Infelizmente, não :( Com o objetivo de se evitar fraudes, após um
            CAD ter sido ativado, não é possível fazer o cancelamento ou
            alteração dos dados que foram informados .
          </p>

          <Heading subtitle size={5}>
            Quais são os casos de multa mais comuns envolvendo a Zona Azul
            Digital?
          </Heading>
          <Content>
            <p>
              Segundo pesquisas em outros municípios, os casos mais frequentes
              de multa estão relacionados a dois motivos principais:
            </p>
            <ol>
              <li>Cadastramento errado da placa do veículo, ou</li>
              <li>
                Utilizar mais de 02 (dois) CAD seguidos para uma mesma vaga.
              </li>
            </ol>
            <p>
              Desta forma, certifique-se de ter cadastrado a placa correta do
              seu veículo e preste muita atenção à regra de Zona Azul. Qualquer
              erro durante esses dois passos acaba trazendo um alto risco de
              infração.
            </p>
          </Content>
        </Container>
      </Section>

      <Footer className="footer">
        <Container>
          <Columns>
            <Columns.Column size={2}>
              <img src={Images.ativo16} alt="" className="img-ativo-192x" />
            </Columns.Column>
            <Columns.Column style={{ padding: "1rem" }}>
              <p>
                { process.env.REACT_APP_COMPANY }
                <br />
                { process.env.REACT_APP_COMPANY_ADDRESS }
                <br />
                CEP: { process.env.REACT_APP_COMPANY_ZIPCOD }
                <br />
                <FontAwesomeIcon icon={faPhone} /> { process.env.REACT_APP_COMPANY_CONTACT_1 } |{" "}
                <FontAwesomeIcon icon={faMobileScreen} /> { process.env.REACT_APP_COMPANY_CONTACT_2 }
              </p>
            </Columns.Column>
            <Columns.Column textAlign={"right"}>
              <a href="#topo" className="back-to-top">
                <FontAwesomeIcon icon={faChevronUp} />
              </a>
            </Columns.Column>
          </Columns>
        </Container>
      </Footer>
      <WhatsappButton />
    </>
  );
};
